export enum RollCompetitionContentTabs {
  Information = 'information',
  LastRewards = 'last-rewards',
}

export interface RollCompetitionContentTabsProps {
  isLoading?: boolean;
}
